import { render, staticRenderFns } from "./NoticeCat.vue?vue&type=template&id=9d96fff6&"
import script from "./NoticeCat.vue?vue&type=script&lang=js&"
export * from "./NoticeCat.vue?vue&type=script&lang=js&"
import style0 from "./NoticeCat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports